"use client"

import React from "react"
import { MessageSquare, Sparkles } from "lucide-react"
import { cn } from "@/lib/utils"

interface ExplorerChatEmptyProps {
  className?: string
}

export const ExplorerChatEmpty: React.FC<ExplorerChatEmptyProps> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center h-full w-full p-6 text-center",
        className
      )}
    >
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-primary/10 rounded-full blur-xl" />
        <div className="relative bg-primary/5 rounded-full p-6">
          <MessageSquare className="h-12 w-12 text-primary" />
        </div>
      </div>
      
      <h3 className="text-lg font-semibold mb-2">Start a conversation</h3>
      <p className="text-sm text-muted-foreground max-w-sm mb-4">
        Ask questions about your repository structure, code organization, or
        explore your codebase.
      </p>
      
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <Sparkles className="h-3 w-3" />
        <span>Powered by Infinitcode AI</span>
      </div>
    </div>
  )
}

